import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  SectionContextProvider,
  EditableToken,
} from '@vibesites/runtime/react';

// ============================================================================
// Component
// ============================================================================

export function InteractiveMapSection() {
  const mapSlot = useBlockSlot('interactivemapsection.map_block', {
    defaultValue: 'engrain-sitemap',
  });

  return (
    <section className="bg-[var(--vibe-color-background)] pb-10 md:pb-14">
      {/* Constrain the Sightmap iframe so side gutters remain for page scroll */}
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <EditableToken
          path="interactivemapsection.map_block"
          as="div"
          className="min-h-[400px] md:min-h-[500px]"
        >
          {mapSlot ? (
            <SectionContextProvider sectionId={mapSlot.sectionId}>
              <mapSlot.BlockComponent sectionId={mapSlot.sectionId} />
            </SectionContextProvider>
          ) : (
            <div>No block selected</div>
          )}
        </EditableToken>
      </div>
    </section>
  );
}

// ============================================================================
// Schema
// ============================================================================

export const contentSchema: ComponentContentSchema = {
  slot: 'InteractiveMapSection',
  displayName: 'Interactive Map Section',
  tokens: {
    'interactivemapsection.map_block': {
      label: 'Map Block',
      type: 'block',
      defaultValue: 'engrain-sitemap',
      acceptedBlockCategories: ['Integrations', 'Embeds'],
    },
  },
  slotGroups: {},
  collectionBindings: {},
};

(InteractiveMapSection as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default InteractiveMapSection;
